import { _myInformation, MyInformationItem } from "../../indexDB/data";

export const handleNotify = async ({
  title = "Nouvelle notification",
  body,
  icon = "/logo-sapheer.svg",
}: {
  title?: string;
  body: string;
  icon?: string;
}) => {
  const display = await _myInformation.getItem(
    MyInformationItem.RECEIVED_NOTIFICATION,
  );
  if (display) {
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission();
    }
    if (Notification.permission === "granted") {
      new Notification(title, {
        body,
        icon,
      });
    }
  }
};
